export default {"src":"/_next/static/media/economicsBg.40b54b4a.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};